
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppDesktopAppConfig from "@/components/settings-default/DesktopAppConfig.vue";

export default Vue.extend({
	computed: {
		path(): any[] {
			return [{
				to: "/settings/plugins", value: this.$ct("plugins")
			},      {value: this.$ct("winfakt-desktop-server")}] as IBreadCrumb[];
		},
	},
	methods: {

	},
	components: {
		AppDesktopAppConfig
	},
	i18nEx: {
		componentPrefix: "components.settings-plugin"
	}
});
